import { FieldConfiguration } from '@/types';

// Legacy field configurations (used for existing booking types created before the update)
// These have most fields visible by default (the old behavior)
export const generateLegacyFieldConfigurations = (): FieldConfiguration[] => {
  const fields: FieldConfiguration[] = [
    { fieldName: 'Status', placeholder: 'Select status', defaultPlaceholder: 'Select status', isVisible: true, isRequired: true, isCompulsory: true, showTooltip: true },
    { fieldName: 'Colour', placeholder: 'Select colour', defaultPlaceholder: 'Select colour', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: false },
    { fieldName: 'Booking Reference', placeholder: 'Enter booking reference', defaultPlaceholder: 'Enter booking reference', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: false },
    { fieldName: 'Project', placeholder: 'Select project', defaultPlaceholder: 'Select project', isVisible: true, isRequired: true, isCompulsory: true, showTooltip: true },
    { fieldName: 'Cost Centre', placeholder: 'Select cost centre', defaultPlaceholder: 'Select cost centre', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: false },
    { fieldName: 'Customer', placeholder: 'Select customer', defaultPlaceholder: 'Select customer', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: true },
    { fieldName: 'Description', placeholder: 'Enter description', defaultPlaceholder: 'Enter description', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: false },
    { fieldName: 'Location', placeholder: 'Enter location', defaultPlaceholder: 'Enter location', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: true },
    { fieldName: 'Details', placeholder: 'Enter details', defaultPlaceholder: 'Enter details', isVisible: true, isRequired: false, isCompulsory: false, showTooltip: true },
    { fieldName: 'From', placeholder: 'Select start date/time', defaultPlaceholder: 'Select start date/time', isVisible: true, isRequired: true, isCompulsory: true, showTooltip: true },
    { fieldName: 'To', placeholder: 'Select end date/time', defaultPlaceholder: 'Select end date/time', isVisible: true, isRequired: true, isCompulsory: true, showTooltip: true },
  ];

  // Add User Char 1-20 (all visible in legacy)
  for (let i = 1; i <= 20; i++) {
    fields.push({
      fieldName: `User Char ${i}`,
      placeholder: `Enter user char ${i}`,
      defaultPlaceholder: `Enter user char ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
    });
  }

  // Add User Number 1-10
  for (let i = 1; i <= 10; i++) {
    fields.push({
      fieldName: `User Number ${i}`,
      placeholder: `Enter user number ${i}`,
      defaultPlaceholder: `Enter user number ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
    });
  }

  // Add User Flag 1-10
  for (let i = 1; i <= 10; i++) {
    fields.push({
      fieldName: `User Flag ${i}`,
      placeholder: `Select user flag ${i}`,
      defaultPlaceholder: `Select user flag ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
    });
  }

  // Add User Date 1-10
  for (let i = 1; i <= 10; i++) {
    fields.push({
      fieldName: `User Date ${i}`,
      placeholder: `Select user date ${i}`,
      defaultPlaceholder: `Select user date ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
    });
  }

  // Add User Notes 1-5
  for (let i = 1; i <= 5; i++) {
    fields.push({
      fieldName: `User Notes ${i}`,
      placeholder: `Enter user notes ${i}`,
      defaultPlaceholder: `Enter user notes ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
    });
  }

  // Add User Time 1-5
  for (let i = 1; i <= 5; i++) {
    fields.push({
      fieldName: `User Time ${i}`,
      placeholder: `Enter user time ${i}`,
      defaultPlaceholder: `Enter user time ${i}`,
      isVisible: false,
      isRequired: false,
      isCompulsory: false,
      showTooltip: false,
    });
  }

  fields.push({
    fieldName: 'Cost Centre Task',
    placeholder: 'Select cost centre task',
    defaultPlaceholder: 'Select cost centre task',
    isVisible: false,
    isRequired: false,
    isCompulsory: false,
    showTooltip: false,
  });

  return fields;
};
